import { IKiosksFilters } from '../types/kiosks';

export const defaultKiosksFilters: IKiosksFilters = {
  search: '',
  sortDir: null,
  sortField: null,
  branchOption: null,
  statusOption: null,
};
